/* NYLA theme behaviour
   drawer · announcement rotator · slideshow · scroll reveal · cart drawer
   product gallery · quantity steppers · variant picker */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------- menu drawer */
  var drawer = $('[data-drawer]');
  var backdrop = $('[data-drawer-backdrop]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });

  /* ---------------------------------------------- announcement rotator */
  var bar = $('[data-announce]');
  if (bar) {
    var msgs = $$('.announce__msg', bar);
    var mi = 0;
    var isTicker = bar.classList.contains('announce--ticker');

    // Keep the scroll speed even: a long message has further to travel, so
    // give it proportionally longer rather than whipping it past.
    var fitTicker = function () {
      var inner = $('.announce__inner', bar);
      var wrap = inner && inner.querySelector('div');
      var msg = $('.announce__msg.is-active', bar);
      if (!wrap || !msg) return;
      var base = parseFloat(getComputedStyle(inner).getPropertyValue('--ticker-speed')) || 14;
      var w = wrap.clientWidth || 1;
      var d = base * ((w + msg.scrollWidth) / (w * 2));
      msg.style.animationDuration = Math.min(40, Math.max(5, d)).toFixed(2) + 's';
    };

    var showMsg = function (i) {
      msgs.forEach(function (m, n) { m.classList.toggle('is-active', n === i); });
      if (isTicker) fitTicker();
    };
    if (isTicker) fitTicker();

    if (msgs.length > 1) {
      var stepMsg = function (d) {
        mi = (mi + d + msgs.length) % msgs.length;
        showMsg(mi);
      };
      var mp = $('[data-announce-prev]', bar), mn = $('[data-announce-next]', bar);
      if (mp) mp.addEventListener('click', function () { stepMsg(-1); });
      if (mn) mn.addEventListener('click', function () { stepMsg(1); });

      if (!reduceMotion) {
        if (isTicker) {
          // A timer would cut the slide off mid-sentence, so wait for the
          // message to finish crossing the bar before showing the next one.
          bar.addEventListener('animationiteration', function (e) {
            if (e.target.classList.contains('announce__msg') && e.target.classList.contains('is-active')) {
              stepMsg(1);
            }
          });
        } else {
          setInterval(function () { stepMsg(1); }, 5000);
        }
      }
    }
    var mc = $('[data-announce-close]', bar);
    if (mc) mc.addEventListener('click', function () { bar.remove(); });
  }

  /* ---------------------------------------------- slideshow */
  $$('[data-slideshow]').forEach(function (box) {
    var slides = $$('[data-slide]', box);
    if (!slides.length) return;
    var dots = $$('[data-slide-to]', box);
    var idx = 0, timer = null;
    var interval = (parseInt(box.getAttribute('data-interval'), 10) || 6) * 1000;
    var autoplay = box.getAttribute('data-autoplay') === 'true' && !reduceMotion && slides.length > 1;

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function start() { if (autoplay) { stop(); timer = setInterval(function () { go(idx + 1); }, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prev = $('[data-slide-prev]', box), next = $('[data-slide-next]', box);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); start(); });
    });

    // swipe
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(idx + (dx < 0 ? 1 : -1));
      x0 = null; start();
    }, { passive: true });

    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    go(0); start();
  });

  /* ---------------------------------------------- scroll reveal */
  document.documentElement.classList.add('reveal-ready');
  var revealTargets = $$('[data-reveal], [data-reveal-stagger]');
  if (revealTargets.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealTargets.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------------------------------------------- accordions */
  $$('[data-accordion] .accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion__item');
      if (item) item.classList.toggle('is-open');
    });
  });
  $$('[data-footer-col] h4').forEach(function (h) {
    h.addEventListener('click', function () {
      if (window.innerWidth < 750) h.parentElement.classList.toggle('is-open');
    });
  });

  /* ---------------------------------------------- product gallery
     One track serves both breakpoints: on phones it is a swipeable
     scroll-snap slider, on desktop only the active slide is displayed and
     the thumbnails drive it. */
  var gallery = $('[data-gallery]');
  var galleryIndex = 0;
  if (gallery) {
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('.product__slide', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var dots = $$('[data-gallery-dots] .product__dot', gallery);

    var isSwipe = function () { return window.matchMedia('(max-width: 749px)').matches; };

    var mark = function (i) {
      galleryIndex = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    };

    var goTo = function (i) {
      if (i < 0 || i >= slides.length) return;
      mark(i);
      if (isSwipe() && track && slides[i]) {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    };

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });

    // swiping the track is the source of truth on mobile
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        if (!isSwipe()) return;
        clearTimeout(st);
        st = setTimeout(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestD = Infinity;
          slides.forEach(function (s, n) {
            var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < bestD) { bestD = d; best = n; }
          });
          mark(best);
          var activeThumb = thumbs[best];
          if (activeThumb && activeThumb.scrollIntoView) {
            activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }, 90);
      }, { passive: true });
    }

    mark(0);
  }

  /* ---------------------------------------------- quantity steppers */
  function bindQty(scope) {
    $$('[data-qty]', scope || document).forEach(function (wrap) {
      if (wrap.__bound) return;
      wrap.__bound = true;
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        if (b.hasAttribute('data-line-change')) return; // cart lines handled separately
        b.addEventListener('click', function () {
          var delta = b.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var val = parseInt(input.value || '1', 10) + delta;
          input.value = val < min ? min : val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  bindQty();

  /* ---------------------------------------------- variant picker */
  var pform = $('[data-product-form]');
  if (pform && window.__NYLA_VARIANTS__) {
    var variants = window.__NYLA_VARIANTS__;
    var idField = $('[data-variant-id]', pform);
    var priceEl = $('[data-product-price]');
    var addBtn  = $('[data-add-to-cart]', pform);
    var syncVariant = function () {
      var chosen = $$('input[type=radio]:checked', pform).map(function (i) { return i.value; });
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return !chosen[i] || o === chosen[i]; });
      })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
      }
    };
    $$('input[type=radio]', pform).forEach(function (r) { r.addEventListener('change', syncVariant); });
    syncVariant();
  }

  /* The WooCommerce descriptions arrived with autoplaying <video> embeds
     pointing at the old wp-content URLs. Strip them so nothing downloads,
     plays, or knocks the description layout about. */
  (function stripImportedEmbeds() {
    $$('.rte video, .rte iframe, .rte source[src*="wp-content"]').forEach(function (el) {
      var host = el.tagName === 'SOURCE' ? el.parentElement : el;
      if (!host) return;
      var wrap = host.parentElement;
      host.removeAttribute('src');
      if (host.pause) { try { host.pause(); } catch (e) {} }
      if (host.parentNode) host.parentNode.removeChild(host);
      // drop the empty <p>/<figure> the embed was sitting in
      if (wrap && wrap !== document.body && !wrap.textContent.trim() && !wrap.querySelector('img,a,video,iframe')) {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }
    });
  })();

  /* ---------------------------------------------- before / after compare
     A range input sits invisibly over the image, so dragging, tapping and
     the arrow keys all work, and screen readers get a real control. */
  $$('[data-before-after]').forEach(function (box) {
    var input = $('[data-ba-input]', box);
    if (!input) return;
    var paint = function () {
      box.style.setProperty('--ba-pos', input.value + '%');
    };
    input.addEventListener('input', paint);
    input.addEventListener('change', paint);
    paint();
  });

  /* ---------------------------------------------- countdown */
  $$('[data-countdown]').forEach(function (box) {
    var raw = (box.getAttribute('data-end') || '').trim();
    if (!raw || raw.indexOf('T') === 0) return;
    var end = new Date(raw).getTime();
    if (isNaN(end)) return;                       // a mistyped date must not break the page
    var clock = $('[data-countdown-clock]', box);
    var done = $('[data-countdown-done]', box);
    var hide = box.getAttribute('data-hide') === 'true';
    var out = {
      d: $('[data-cd-days]', box), h: $('[data-cd-hours]', box),
      m: $('[data-cd-mins]', box), s: $('[data-cd-secs]', box)
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer = null;
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) {
        if (timer) clearInterval(timer);
        if (hide) { box.hidden = true; return; }
        if (clock) clock.hidden = true;
        if (done) done.hidden = false;
        return;
      }
      var secs = Math.floor(left / 1000);
      if (out.d) out.d.textContent = Math.floor(secs / 86400);
      if (out.h) out.h.textContent = pad(Math.floor(secs / 3600) % 24);
      if (out.m) out.m.textContent = pad(Math.floor(secs / 60) % 60);
      if (out.s) out.s.textContent = pad(secs % 60);
    };
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------------------------------------------- cart drawer */
  var cartDrawer = $('[data-cart-drawer]');
  var cartBackdrop = $('[data-cart-backdrop]');

  /* Hiding the page scrollbar makes the layout jump sideways behind the
     drawer, which reads as the drawer stuttering. Pad by the scrollbar's
     width so nothing moves. */
  function lockScroll(on) {
    if (on) {
      var gap = window.innerWidth - document.documentElement.clientWidth;
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function openCart(open) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (cartBackdrop) cartBackdrop.classList.toggle('is-open', open);
    lockScroll(open);
  }

  function money(cents) {
    var amount = cents / 100;
    var fmt = window.__NYLA_MONEY_FORMAT__ || '';
    var withComma = function (v, decimals) {
      var n = decimals ? v.toFixed(2) : Math.round(v).toString();
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    if (fmt) {
      // Shopify money formats look like "Rs {{amount_no_decimals_with_comma_separator}}"
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator': return withComma(amount, false);
          case 'amount_with_comma_separator':
          case 'amount': return withComma(amount, true);
          default: return withComma(amount, false);
        }
      }).trim();
    }
    return 'Rs ' + withComma(amount, false);
  }

  function refreshCart() {
    if (!cartDrawer) return Promise.resolve();
    cartDrawer.classList.add('is-loading');
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer-items' : '/?sections=cart-drawer-items')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-items'];
        var body = $('[data-cart-body]', cartDrawer);
        if (html && body) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('.shopify-section') || tmp;
          body.innerHTML = inner.innerHTML;
          bindCartLines();
          bindQty(body);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
        $$('.icon-btn__count').forEach(function (el) { el.textContent = cart.item_count; });
        var total = $('[data-cart-total]', cartDrawer);
        if (total) total.textContent = money(cart.total_price);
        if (typeof paintShipBars === 'function') paintShipBars(cart.total_price);
        if (typeof paintWish === 'function') paintWish();
        decorateCheckout();
      })
      .catch(function () { /* keep the shopper moving even if refresh fails */ })
      .then(function () { cartDrawer.classList.remove('is-loading'); });
  }

  function bindCartLines() {
    $$('[data-line-change]').forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-line-change');
        var qty = btn.getAttribute('data-line-qty');
        cartDrawer.classList.add('is-loading');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
        }).then(function () { return refreshCart(); });
      });
    });
  }
  bindCartLines();

  // open drawer from the cart icon instead of navigating
  if (cartDrawer) {
    $$('a[href$="/cart"], a[href*="/cart?"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.hasAttribute('data-no-drawer')) return;
        e.preventDefault();
        openCart(true);
        refreshCart();
      });
    });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { openCart(false); }); });
    if (cartBackdrop) cartBackdrop.addEventListener('click', function () { openCart(false); });

    // add to cart without leaving the page
    $$('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status && res.status !== 200) throw new Error(res.description || 'Could not add to cart');
            openCart(true);
            return refreshCart();
          })
          .catch(function (err) {
            alert(err.message || 'Sorry, that item could not be added.');
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
      });
    });
  }


  /* ---------------------------------------------- free-shipping progress */
  function paintShipBars(totalCents) {
    $$('[data-ship-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      if (!threshold) return;
      var total = typeof totalCents === 'number' ? totalCents : (parseInt(bar.getAttribute('data-total'), 10) || 0);
      bar.setAttribute('data-total', total);
      var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      var fill = $('[data-ship-fill]', bar);
      if (fill) fill.style.width = pct + '%';
      var text = $('[data-ship-text]', bar);
      if (text) {
        if (total >= threshold) {
          text.innerHTML = '<strong>' + (bar.getAttribute('data-done') || "You've unlocked free shipping") + '</strong>';
        } else {
          text.textContent = "You're " + money(threshold - total) + ' away from free shipping';
        }
      }
      bar.classList.toggle('is-complete', total >= threshold);
    });
  }
  paintShipBars();

  /* ---------------------------------------------- quick add from a card */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-quick-add]') : null;
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-quick-add');
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) throw new Error(res.description || 'Could not add');
        if (typeof openCart === 'function') openCart(true);
        return typeof refreshCart === 'function' ? refreshCart() : null;
      })
      .catch(function (err) { alert(err.message || 'Sorry, that item could not be added.'); })
      .then(function () { b.disabled = false; b.textContent = label; });
  });

  /* ---------------------------------------------- discount code box
     A theme cannot change line prices, so the code is registered with
     Shopify (/discount/CODE) and carried on the cart form. The saving is
     applied at checkout, and we say so rather than faking a total. */
  function setDiscountState(scope, code, ok) {
    var state = $('[data-discount-state]', scope);
    if (!state) return;
    if (!code) { state.hidden = true; state.innerHTML = ''; return; }
    state.hidden = false;
    state.className = 'discount__state' + (ok ? ' is-ok' : ' is-err');
    if (ok) {
      state.innerHTML = '<span class="discount__chip">' + code +
        ' <button type="button" class="discount__clear" data-discount-clear aria-label="Remove discount">&times;</button></span>' +
        '<span class="discount__ok">applied &mdash; saving shows at checkout</span>';
    } else {
      state.textContent = "We couldn't apply that code.";
    }
  }

  function storeDiscount(code) {
    try {
      if (code) sessionStorage.setItem('nyla_discount', code);
      else sessionStorage.removeItem('nyla_discount');
    } catch (e) {}
    memoDiscount = code || '';
    $$('[data-discount-field]').forEach(function (f) { f.value = code || ''; });
  }

  function applyDiscountCode(code, scope) {
    if (!code) return;
    var btn = scope ? $('[data-discount-apply]', scope) : null;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    var finish = function (ok) {
      if (ok) { storeDiscount(code); decorateCheckout(); }
      setDiscountState(scope, code, ok);
      if (btn) { btn.disabled = false; btn.textContent = label; }
    };

    // /discount/CODE registers the code, then the cart tells us whether
    // Shopify actually accepted it. It always redirects, so its own status
    // says nothing — the cart is the only honest answer.
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var list = (cart && cart.discount_codes) || [];
        var wanted = code.toUpperCase();
        var entry = list.filter(function (d) {
          return String(d.code || '').toUpperCase() === wanted;
        })[0];
        // Shopify only lists a code once it has judged it; if it is silent we
        // let the code stand and checkout has the final say.
        finish(entry ? entry.applicable !== false : true);
        if (typeof refreshCart === 'function') refreshCart();
      })
      .catch(function () { finish(true); });
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest ? e.target.closest('[data-discount-apply]') : null;
    if (apply) {
      e.preventDefault();
      var scope = apply.closest('[data-discount]');
      var input = $('[data-discount-input]', scope);
      var code = (input && input.value || '').trim();
      if (!code) return;
      applyDiscountCode(code, scope);
      return;
    }
    var clear = e.target.closest ? e.target.closest('[data-discount-clear]') : null;
    if (clear) {
      e.preventDefault();
      var box = clear.closest('[data-discount]');
      storeDiscount('');
      setDiscountState(box, '', false);
      var ci = $('[data-discount-input]', box);
      if (ci) ci.value = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest ? e.target.closest('[data-discount-input]') : null;
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('[data-discount]');
    var btn = $('[data-discount-apply]', scope);
    if (btn) btn.click();
  });

  // restore a code the shopper already applied this session
  (function () {
    var existing = currentDiscount();
    if (!existing) return;
    $$('[data-discount]').forEach(function (scope) {
      var input = $('[data-discount-input]', scope);
      if (input) input.value = existing;
      setDiscountState(scope, existing, true);
    });
    $$('[data-discount-field]').forEach(function (f) { if (!f.value) f.value = existing; });
  })();

  /* ---------------------------------------------- testimonials carousel */
  $$('[data-testimonials]').forEach(function (box) {
    var track = $('[data-testimonials-track]', box);
    var cards = $$('.testimonial', track);
    var dotsWrap = $('[data-testimonials-dots]', box.parentElement) || $('[data-testimonials-dots]', box);
    if (!track || !cards.length) return;

    var page = 0;

    function perView() {
      var w = window.innerWidth;
      if (w >= 990) return 3;
      if (w >= 750) return 2;
      return 1;
    }
    function pages() { return Math.max(1, Math.ceil(cards.length / perView())); }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.className = 'testimonials__dot' + (i === page ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to review page ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
        dotsWrap.appendChild(b);
      }
    }
    function go(n) {
      var total = pages();
      page = Math.max(0, Math.min(n, total - 1));
      var shift = page * 100;
      track.style.transform = 'translateX(-' + shift + '%)';
      $$('.testimonials__dot', dotsWrap).forEach(function (d, i) {
        d.classList.toggle('is-active', i === page);
      });
    }

    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(page + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { buildDots(); go(Math.min(page, pages() - 1)); }, 150);
    });

    buildDots(); go(0);
  });


  /* ---------------------------------------------- product tabs */
  $$('[data-tabs]').forEach(function (box) {
    var btns = $$('.tabs__btn', box);
    var panels = $$('.tabs__panel', box);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-tab');
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        panels.forEach(function (pnl) {
          pnl.classList.toggle('is-active', pnl.getAttribute('data-panel') === key);
        });
      });
    });
  });
  // deep link to the reviews tab
  if (location.hash === '#product-reviews') {
    var rb = $('[data-tab="reviews"]');
    if (rb) { rb.click(); setTimeout(function () { rb.scrollIntoView({ block: 'center' }); }, 60); }
  }
  $$('a[href="#product-reviews"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var rb = $('[data-tab="reviews"]');
      if (!rb) return;
      e.preventDefault();
      rb.click();
      rb.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
  });

  /* ---------------------------------------------- image zoom */
  var zoomBox = $('[data-zoom]');
  if (zoomBox) {
    var zoomImg = $('[data-zoom-img]', zoomBox);
    function setZoom(open) {
      zoomBox.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }
    $$('[data-zoom-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var slide = $$('.product__slide')[galleryIndex] || $('.product__slide.is-active');
        var img = slide ? slide.querySelector('img') : null;
        if (img && zoomImg) {
          zoomImg.src = img.getAttribute('data-full') || img.src;
          zoomImg.alt = img.alt || '';
        }
        setZoom(true);
      });
    });
    $$('[data-zoom-close]').forEach(function (b) { b.addEventListener('click', function () { setZoom(false); }); });
    zoomBox.addEventListener('click', function (e) { if (e.target === zoomBox) setZoom(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setZoom(false); });
  }

  /* ---------------------------------------------- sticky buy bar */
  var sticky = $('[data-sticky-buy]');
  var buyForm = $('[data-product-form]');
  if (sticky && buyForm) {
    var addBtnMain = $('[data-add-to-cart]', buyForm);
    var stickyAdd = $('[data-sticky-add]', sticky);
    if (stickyAdd && addBtnMain) {
      stickyAdd.addEventListener('click', function () { addBtnMain.click(); });
    }
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io2.observe(buyForm);
    }
  }

  /* ---------------------------------------------- share + wishlist */
  $$('[data-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var data = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href).then(function () {
          var old = b.innerHTML;
          b.textContent = 'Link copied';
          setTimeout(function () { b.innerHTML = old; }, 1600);
        });
      }
    });
  });
  /* ---------------------------------------------- wishlist (per browser) */
  var WISH_KEY = 'nyla_wishlist';
  function wishList() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function wishSave(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintWish() {
    var list = wishList();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) !== -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (!b) return;
    e.preventDefault();
    var handle = b.getAttribute('data-wish');
    var list = wishList();
    var at = list.indexOf(handle);
    if (at === -1) list.push(handle); else list.splice(at, 1);
    wishSave(list);
    paintWish();
  });
  paintWish();

  /* ---------------------------------------------- "Show More" description */
  $$('[data-more]').forEach(function (box) {
    var text = $('[data-more-text]', box);
    var btn = $('[data-more-toggle]', box);
    if (!text || !btn) return;
    // only worth a toggle when the copy is actually taller than the clamp
    requestAnimationFrame(function () {
      if (text.scrollHeight <= text.clientHeight + 4) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more');
      });
    });
  });

  /* ---------------------------------------------- header search */
  var searchBar = $('[data-search-bar]');
  if (searchBar) {
    var searchInput = $('[data-search-input]', searchBar);
    var setSearch = function (open) {
      searchBar.hidden = !open;
      if (open && searchInput) searchInput.focus();
    };
    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () { setSearch(searchBar.hidden); });
    });
    $$('[data-search-close]').forEach(function (b) {
      b.addEventListener('click', function () { setSearch(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSearch(false); });
  }


  /* ---------------------------------------------- deal builder (all 5 deal types) */
  function money(cents) {
    var amount = cents / 100;
    var fmt = window.__NYLA_MONEY_FORMAT__ || '';
    var withComma = function (v, decimals) {
      var n = decimals ? v.toFixed(2) : Math.round(v).toString();
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    if (fmt) {
      // Shopify money formats look like "Rs {{amount_no_decimals_with_comma_separator}}"
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator': return withComma(amount, false);
          case 'amount_with_comma_separator':
          case 'amount': return withComma(amount, true);
          default: return withComma(amount, false);
        }
      }).trim();
    }
    return 'Rs ' + withComma(amount, false);
  }


  /* a discount code captured by a deal is carried through to checkout and
     shown in the cart so the shopper knows it is coming */
  var memoDiscount = '';
  function currentDiscount() {
    if (memoDiscount) return memoDiscount;
    try { return sessionStorage.getItem('nyla_discount') || ''; } catch (e) { return ''; }
  }
  function decorateCheckout() {
    var code = currentDiscount();
    if (!code) return;
    $$('a[href*="/checkout"], button[name="checkout"]').forEach(function (el) {
      if (el.tagName === 'A') {
        var href = el.getAttribute('href') || '/checkout';
        if (href.indexOf('discount=') === -1) {
          el.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(code));
        }
      }
    });
    var foot = $('[data-cart-drawer] .cart-drawer__foot');
    if (foot && !$('[data-discount-note]', foot)) {
      var note = document.createElement('p');
      note.className = 'cart__note cart__note--discount';
      note.setAttribute('data-discount-note', '');
      note.textContent = code + ' will be applied at checkout';
      foot.insertBefore(note, foot.firstChild);
    }
  }
  decorateCheckout();

  function openCartAfterAdd() {
    var cd = $('[data-cart-drawer]');
    if (!cd) { window.location = '/cart'; return; }
    /* Swapping the contents while the drawer is mid-slide made it flicker.
       Fetch first, then open on the next frame with the panel already built. */
    var cb = $('[data-cart-backdrop]');
    var reveal = function () {
      cd.classList.add('is-open');
      cd.setAttribute('aria-hidden', 'false');
      if (cb) cb.classList.add('is-open');
      lockScroll(true);
    };
    if (typeof refreshCart === 'function') {
      refreshCart().then(function () { requestAnimationFrame(reveal); });
    } else {
      reveal();
    }
  }

  function initDeal(box) {
    if (!box || box.__dealReady) return;
    box.__dealReady = true;

    var type = box.getAttribute('data-type');
    var min = parseInt(box.getAttribute('data-min'), 10) || 3;
    var pct = parseFloat(box.getAttribute('data-percent')) || 0;
    var slotDeal = ['lipstick_duo', 'trio_bundle', 'blush_lip'].indexOf(type) !== -1;

    var bar = $('[data-deal-bar]', box);
    var confirmBox = $('[data-deal-confirm]', box);
    var summaryEl = $('[data-deal-summary]', box);
    var addBtns = $$('[data-deal-add]', box);
    var hintTemplate = ($('[data-deal-hint]', box) || {}).textContent || '';

    function paint(state) {
      var setText = function (sel, val) {
        $$(sel, box).forEach(function (el) { el.textContent = val; });
      };
      var setHidden = function (sel, hide, val) {
        $$(sel, box).forEach(function (el) { el.hidden = hide; if (val !== undefined) el.textContent = val; });
      };
      setText('[data-deal-count]', state.count);
      setText('[data-deal-hint]', state.hint);
      setText('[data-deal-now]', money(state.now));
      setText('[data-deal-now-inline]', money(state.now));
      setHidden('[data-deal-was]', !state.saving, money(state.was));
      setHidden('[data-deal-was-inline]', !state.saving, money(state.was));
      setHidden('[data-deal-save]', !state.saving, 'Save ' + money(state.was - state.now));
      setHidden('[data-deal-save-inline]', !state.saving, 'Save ' + money(state.was - state.now));
      addBtns.forEach(function (b) { b.disabled = !state.ready; });
      if (bar) bar.classList.toggle('is-visible', state.count > 0);
      if (confirmBox) confirmBox.classList.toggle('is-ready', state.ready);
      if (summaryEl) {
        summaryEl.innerHTML = state.lines.map(function (l) {
          return '<div class="deal__confirm-line"><span>' + l.label + '</span><strong>' + l.value + '</strong></div>';
        }).join('');
      }
    }

    var discountCode = (box.getAttribute('data-deal-discount') || box.getAttribute('data-discount') || '').trim();

    /* The session remembers the last deal's code, which meant a shopper who
       looked at Buy 3 Get 1 first carried Buy3Get1 onto Make Your Own Bundle.
       The deal on screen owns the code — drop anything left over from another. */
    if (discountCode && currentDiscount() && currentDiscount() !== discountCode) {
      memoDiscount = '';
      try { sessionStorage.removeItem('nyla_discount'); } catch (e) {}
      var staleNote = $('[data-discount-note]');
      if (staleNote && staleNote.parentNode) staleNote.parentNode.removeChild(staleNote);
      $$('a[href*="discount="]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('href')
          .replace(/([?&])discount=[^&]*&?/, '$1').replace(/[?&]$/, ''));
      });
    }

    function applyDiscount() {
      if (!discountCode) return Promise.resolve();
      // Two belts: hitting /discount/CODE attaches it to this session, and we
      // remember it so the checkout button carries ?discount= as a fallback.
      memoDiscount = discountCode;
      try { sessionStorage.setItem('nyla_discount', discountCode); } catch (e) {}
      return fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' })
        .catch(function () { /* the checkout link still carries the code */ })
        .then(function () { decorateCheckout(); });
    }

    function addToCart(payload, reset) {
      var btns = addBtns.slice();
      var labels = btns.map(function (b) { return b.textContent; });
      btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error(res.description || 'Could not add this bundle');
          return applyDiscount().then(function () {
            reset();
            closeDealModal();
            openCartAfterAdd();
          });
        })
        .catch(function (err) { alert(err.message || 'Sorry, that could not be added.'); })
        .then(function () {
          btns.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; });
        });
    }

    /* ---------- slot deals ---------- */
    if (slotDeal) {
      var slots = $$('[data-slot]', box);
      var bundleVariant = box.getAttribute('data-bundle-variant');
      var bundlePrice = parseInt(box.getAttribute('data-bundle-price'), 10) || 0;

      var picksOf = function () {
        return slots.map(function (slot) {
          var opt = $('[data-slot-option].is-chosen', slot);
          return opt ? {
            label: slot.getAttribute('data-slot-label'),
            title: opt.getAttribute('data-title'),
            price: parseInt(opt.getAttribute('data-price'), 10) || 0
          } : null;
        });
      };

      // An empty step is valued at the cheapest shade on offer in it, so the
      // price box shows the bundle price and its saving from the start
      // instead of Rs 0 until something is picked.
      var slotPrice = function (slot) { return parseInt(slot.getAttribute('data-slot-price'), 10) || 0; };

      var renderSlots = function () {
        var picks = picksOf();
        var done = picks.filter(Boolean);
        var ready = done.length === slots.length && slots.length > 0 && !!bundleVariant;
        var was = slots.reduce(function (a, slot, i) { return a + (picks[i] ? picks[i].price : slotPrice(slot)); }, 0);
        var left = slots.length - done.length;
        paint({
          count: done.length,
          hint: ready ? 'Your bundle is ready' : 'Choose ' + left + ' more to complete the bundle',
          was: was,
          now: bundlePrice || was,
          saving: bundlePrice > 0 && was > bundlePrice,
          ready: ready,
          lines: done.map(function (p) { return { label: p.label, value: p.title }; })
        });
      };

      slots.forEach(function (slot) {
        $$('[data-slot-option]', slot).forEach(function (opt) {
          opt.addEventListener('click', function () {
            $$('[data-slot-option]', slot).forEach(function (o) { o.classList.remove('is-chosen'); });
            opt.classList.add('is-chosen');
            slot.classList.add('is-filled');
            var chosen = $('[data-slot-chosen]', slot);
            if (chosen) chosen.textContent = opt.getAttribute('data-title');
            renderSlots();
            // nudge the shopper to the next empty slot
            var next = slots.filter(function (s) { return !$('[data-slot-option].is-chosen', s); })[0];
            if (next && !reduceMotion) next.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        });
      });

      addBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var props = {};
          picksOf().forEach(function (p) { if (p) props[p.label] = p.title; });
          addToCart(
            { items: [{ id: parseInt(bundleVariant, 10), quantity: 1, properties: props }] },
            function () {
              slots.forEach(function (slot) {
                slot.classList.remove('is-filled');
                $$('[data-slot-option]', slot).forEach(function (o) { o.classList.remove('is-chosen'); });
                var c = $('[data-slot-chosen]', slot);
                if (c) c.textContent = 'Nothing chosen yet';
              });
              renderSlots();
            }
          );
        });
      });

      renderSlots();
      return;
    }

    /* ---------- pick-any deals ---------- */
    var items = $$('[data-builder-item]', box);
    var picked = {};

    function totals() {
      var qty = 0, gross = 0, prices = [];
      items.forEach(function (el) {
        var id = el.getAttribute('data-variant');
        var n = picked[id] || 0;
        var price = parseInt(el.getAttribute('data-price'), 10);
        qty += n; gross += n * price;
        for (var i = 0; i < n; i++) prices.push(price);
      });
      prices.sort(function (a, b) { return a - b; });
      return { qty: qty, gross: gross, prices: prices };
    }

    function renderPick() {
      var t = totals();
      var ready, now, hint;
      if (type === 'buy3get1') {
        ready = t.qty >= 4;
        now = ready ? t.gross - t.prices[0] : t.gross;
        hint = ready ? 'Cheapest item is free' : 'Add ' + (4 - t.qty) + ' more to get one free';
      } else {
        ready = t.qty >= min;
        now = ready ? Math.round(t.gross * (1 - pct / 100)) : t.gross;
        hint = ready ? pct + '% off applied to your bundle'
                     : hintTemplate.replace('[min]', min).replace(min + '+', (min - t.qty) + ' more');
      }
      var lines = [];
      items.forEach(function (el) {
        var n = picked[el.getAttribute('data-variant')] || 0;
        if (n) lines.push({ label: el.getAttribute('data-title'), value: '×' + n });
      });
      paint({ count: t.qty, hint: hint, was: t.gross, now: now, saving: ready && now < t.gross, ready: ready, lines: lines });
    }

    items.forEach(function (el) {
      var id = el.getAttribute('data-variant');
      var toggle = $('[data-builder-toggle]', el);
      var qtyBox = $('.builder__qty', el);
      var input = qtyBox ? $('input', qtyBox) : null;
      function sync() {
        var n = picked[id] || 0;
        el.classList.toggle('is-selected', n > 0);
        if (toggle) toggle.hidden = n > 0;
        if (qtyBox) qtyBox.hidden = n === 0;
        if (input) input.value = n;
        renderPick();
      }
      if (toggle) toggle.addEventListener('click', function () { picked[id] = 1; sync(); });
      var plus = $('[data-builder-plus]', el);
      var minus = $('[data-builder-minus]', el);
      if (plus) plus.addEventListener('click', function () { picked[id] = (picked[id] || 0) + 1; sync(); });
      if (minus) minus.addEventListener('click', function () {
        picked[id] = Math.max(0, (picked[id] || 0) - 1);
        if (!picked[id]) delete picked[id];
        sync();
      });
    });

    addBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var lines = Object.keys(picked).map(function (id) {
          return { id: parseInt(id, 10), quantity: picked[id] };
        });
        if (!lines.length) return;
        addToCart({ items: lines }, function () {
          picked = {};
          items.forEach(function (el) {
            el.classList.remove('is-selected');
            var tg = $('[data-builder-toggle]', el); if (tg) tg.hidden = false;
            var qb = $('.builder__qty', el); if (qb) qb.hidden = true;
          });
          renderPick();
        });
      });
    });

    renderPick();
  }

  /* the sticky bar duplicates the inline card, so hide it while that card is on screen */
  function watchConfirm(box) {
    var card = $('[data-deal-confirm]', box);
    if (!card || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        box.classList.toggle('is-confirm-visible', en.isIntersecting);
      });
    }, { threshold: 0.35 }).observe(card);
  }

  $$('[data-deal]').forEach(function (box) { initDeal(box); watchConfirm(box); });

  /* ---------------------------------------------- deal popup (from product pages) */
  var dealModal = null;
  function ensureDealModal() {
    if (dealModal) return dealModal;
    dealModal = document.createElement('div');
    dealModal.className = 'deal-modal';
    dealModal.hidden = true;
    dealModal.setAttribute('role', 'dialog');
    dealModal.setAttribute('aria-modal', 'true');
    dealModal.innerHTML =
      '<div class="deal-modal__backdrop" data-deal-modal-close></div>' +
      '<div class="deal-modal__panel">' +
        '<button type="button" class="deal-modal__close" data-deal-modal-close aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="deal-modal__body"><p class="deal-modal__loading">Loading…</p></div>' +
      '</div>';
    document.body.appendChild(dealModal);
    $$('[data-deal-modal-close]', dealModal).forEach(function (b) {
      b.addEventListener('click', closeDealModal);
    });
    return dealModal;
  }

  function closeDealModal() {
    if (!dealModal || dealModal.hidden) return;
    dealModal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { dealModal.hidden = true; }, 300);
  }

  function openDealModal(url) {
    var m = ensureDealModal();
    var body = $('.deal-modal__body', m);
    body.innerHTML = '<p class="deal-modal__loading">Loading…</p>';
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { m.classList.add('is-open'); });

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-deal]');
        if (!node) throw new Error('no deal on that page');
        body.innerHTML = '';
        body.appendChild(node);
        initDeal(node);
        watchConfirm(node);
      })
      .catch(function () {
        body.innerHTML = '<p class="deal-modal__loading">Could not load this bundle. <a href="' + url + '">Open the page instead</a>.</p>';
      });
  }

  $$('[data-deal-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var url = el.getAttribute('data-deal-open');
      if (!url) return;
      e.preventDefault();
      openDealModal(url);
    });
  });



  /* ---------------------------------------------- deal page image thumbnails */
  $$('[data-deal-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrap = thumb.closest('.deal__media-inner');
      var main = wrap ? wrap.querySelector('img') : null;
      var src = thumb.getAttribute('data-src');
      if (main && src) main.src = src;
      if (wrap) $$('[data-deal-thumb]', wrap).forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------------------------------------------- carousels (slider sections) */
  $$('[data-carousel]').forEach(function (box) {
    var view = $('[data-carousel-viewport]', box);
    var prev = $('[data-carousel-prev]', box);
    var next = $('[data-carousel-next]', box);
    var dotsWrap = $('[data-carousel-dots]', box);
    if (!view) return;

    function step() {
      var first = view.querySelector('.carousel__item');
      return first ? first.getBoundingClientRect().width + 16 : view.clientWidth * 0.8;
    }
    function pages() { return Math.max(1, Math.ceil(view.scrollWidth / Math.max(1, view.clientWidth))); }
    function current() { return Math.round(view.scrollLeft / Math.max(1, view.clientWidth)); }

    function syncNav() {
      if (prev) prev.disabled = view.scrollLeft < 6;
      if (next) next.disabled = view.scrollLeft + view.clientWidth >= view.scrollWidth - 6;
      if (dotsWrap) {
        var cur = current();
        $$('.carousel__dot', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
      }
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      dotsWrap.innerHTML = '';
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.className = 'carousel__dot' + (i === 0 ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () { view.scrollTo({ left: idx * view.clientWidth, behavior: 'smooth' }); });
        })(i);
        dotsWrap.appendChild(b);
      }
    }

    if (prev) prev.addEventListener('click', function () { view.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { view.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    view.addEventListener('scroll', function () { window.requestAnimationFrame(syncNav); }, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { buildDots(); syncNav(); }, 150); });

    buildDots(); syncNav();
  });

  /* ---------------------------------------------- collection page controls */
  $$('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var panel = $('[data-filters]');
      if (!panel) return;
      var open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });
  $$('[data-filter-group] .filter-group__head').forEach(function (h) {
    h.addEventListener('click', function () { h.closest('.filter-group').classList.toggle('is-open'); });
  });
  var sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
  }
  $$('[data-density]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = b.getAttribute('data-density');
      var grid = $('[data-product-grid]');
      if (!grid) return;
      grid.className = grid.className.replace(/grid--d\d/g, '').trim() + ' grid--d' + n;
      $$('[data-density]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      try { localStorage.setItem('nyla_density', n); } catch (e) {}
    });
  });
  (function () {
    var grid = $('[data-product-grid]');
    if (!grid) return;
    var saved = null;
    try { saved = localStorage.getItem('nyla_density'); } catch (e) {}
    if (!saved) return;
    var btn = $('[data-density="' + saved + '"]');
    if (btn) btn.click();
  })();

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDealModal(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); openCart(false); }
  });
})();
